import { render, staticRenderFns } from "./VsEye.vue?vue&type=template&id=1fa613ca&scoped=true&"
import script from "./VsEye.vue?vue&type=script&lang=js&"
export * from "./VsEye.vue?vue&type=script&lang=js&"
import style0 from "./VsEye.vue?vue&type=style&index=0&id=1fa613ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa613ca",
  null
  
)

export default component.exports